import React from 'react';
import IconChevronLeft from '@material-ui/icons/ChevronLeft';
import IconChevronRight from '@material-ui/icons/ChevronRight';
import { IconButton } from '@material-ui/core';
import headerLogoSmall from '../../../../assets/logo.png';
import headerLogo from '../../../../assets/logo-full.png';
import useStyles from '../styles/sideMenu.styles';

const Header = ({ isMenuOpen, onDrawerToggle }) => {
  const styles = useStyles();

  return (
    <div className={styles.drawerHeader}>
      <img src={isMenuOpen ? headerLogo : headerLogoSmall} alt="Brandcil logo" height={50} />
      <IconButton onClick={onDrawerToggle}>
        {isMenuOpen ? <IconChevronLeft className={styles.closeIcon} /> : <IconChevronRight className={styles.closeIcon} />}
      </IconButton>
    </div>
  );
};

export default Header;
